import { getHubAndTierFromApiName } from '../../ums/utils';
export const getOwnedHubsAndSuiteApiNamesFromInventory = products => {
  const ownedHubsAndSuiteApiNames = [];
  for (const product of products) {
    const {
      productLine,
      productApiName
    } = product;
    const {
      hub
    } = getHubAndTierFromApiName(productApiName);
    const isCrmSuite = hub === 'suite';
    if (productLine || isCrmSuite) {
      ownedHubsAndSuiteApiNames.push(productApiName);
    }
  }
  return ownedHubsAndSuiteApiNames;
};